import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateFreeTextMappingCommand from "../EventFreeTextMapping/Models/Commands/CreateFreeTextMappingCommand";
import UpdateFreeTextMappingCommand from "../EventFreeTextMapping/Models/Commands/UpdateFreeTextMappingCommand";
import FreeTextEventMappingLookup from "../EventFreeTextMapping/Models/Lookups/FreeTextEventMappingLookup";
import FreeTextEventMappingSearchCriteria from "../EventFreeTextMapping/Models/Queries/FreeTextEventMappingSearchCriteria";

export interface IFreeTextMappingApiClient {
    getFreeTextMappingsList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FreeTextEventMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FreeTextEventMappingLookup>>>;
    createFreeTextMapping(command: Model.PlainObject<CreateFreeTextMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateFreeTextMapping(command: Model.PlainObject<UpdateFreeTextMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class FreeTextEventMappingApiClient extends Data.ApiClientBase implements IFreeTextMappingApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/ServiceProviderEventKeyword`)
    }

    public getFreeTextMappingsList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FreeTextEventMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FreeTextEventMappingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFreeTextMappingsList?${Utils.getQueryString(payload)}`);
    }

    public createFreeTextMapping(command: Model.PlainObject<CreateFreeTextMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewFreeTextMapping`, command);
    }

    public updateFreeTextMapping(command: Model.PlainObject<UpdateFreeTextMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateFreeTextMapping`, command);
    }
}